import {
  AccountListLastMonth,
  AccountReportLastMonth,
  AccountReportList,
  AccountReportListItem,
  OperationTypes
} from '@shared/types/osi/accountReports';
import {
  ReportDialog as LastMonthReportDialog,
  ViewMode as LastMonthViewMode
} from '@pages/osi/root/_lastMonthReport/types';
import { Nullable } from '@shared/types/utils';
import { AccountType } from '@shared/types/dictionaries';

export interface LastMonthReportService {
  isOpen: boolean;
  isError: boolean;
  isLoading: boolean;
  selectedAccount: AccountListLastMonth | null;
  accountList: AccountReportList | null;
  hookForm: any;
  reportDialog: LastMonthReportDialog;
  freeMode: {
    isOpen: boolean;
  };
  readonly isGridLoading: boolean;
  readonly isGridError: boolean;
  readonly lastMonthReport: Nullable<AccountReportLastMonth>;
  readonly accounts: AccountListLastMonth[];
  readonly osiInfo: any;
  readonly lastMonthFilledListsCount: number;
  readonly allListsFilled: boolean;
  readonly editingListPeriod: string;
  readonly isFreeMode: boolean;

  closeEditor(): void;

  getAllowedCategories(operationType: OperationTypes, accountType: AccountType): any;

  initialize(): Promise<void>;

  reset(): void;

  updateHookForm(hookForm: any): void;

  closeDialog(): void;

  changeViewMode(viewMode: LastMonthViewMode): void;

  selectAccount(account: AccountListLastMonth): Promise<void>;

  applyInitialFilter(): void;

  onFilterChange(checked: boolean): void;

  loadAccount(listId: number): Promise<any>;

  getAccountReportList(): Promise<void>;

  publishReport(): Promise<void>;

  publishReportInFreeMode(data: any): Promise<void>;

  assignFile(file: any): Promise<void>;

  saveList(): Promise<void>;

  closeReportDialog(): void;

  updateItemCategory(itemId: number, categoryId: number | null | string | undefined): void;

  updateDetailCategoryId(detailId: number, categoryId: number | null | string | undefined): void;

  updateItemDetails(item: AccountReportListItem, detailsData: any): void;

  deleteDetail(detailId: any): void;

  closeAssignList(): void;
}

export const LastMonthReportServiceIdentifier = Symbol.for('LastMonthReportService');
